"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeModal = exports.openUnsubscribeLeadSyncingEntityModal = exports.openManageLeadSyncingModal = exports.showOAuthErrorNotification = exports.showConnectAccountErrorNotification = exports.openInstallPixelModal = exports.AdsActionTypes = void 0;

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-lib/utils/actions");

var AdsActionTypes = (0, _namespacedKeyMirror.default)({
  OPEN_INSTALL_PIXEL_MODAL: null,
  SHOW_OAUTH_ERROR_NOTIFICATION: null,
  SHOW_CONNECT_ACCOUNT_ERROR_NOTIFICATION: null,
  OPEN_MANAGE_LEAD_SYNCING_MODAL: null,
  OPEN_UNSUBSCRIBE_LEAD_SYNCING_ENTITY_MODAL: null,
  CLOSE_MODAL: null
}, 'ads');
exports.AdsActionTypes = AdsActionTypes;
var openInstallPixelModal = (0, _fluxActions.createAction)(AdsActionTypes.OPEN_INSTALL_PIXEL_MODAL);
exports.openInstallPixelModal = openInstallPixelModal;
var showConnectAccountErrorNotification = (0, _fluxActions.createAction)(AdsActionTypes.SHOW_CONNECT_ACCOUNT_ERROR_NOTIFICATION, function (title, body) {
  return {
    title: title,
    body: body
  };
});
exports.showConnectAccountErrorNotification = showConnectAccountErrorNotification;
var showOAuthErrorNotification = (0, _fluxActions.createAction)(AdsActionTypes.SHOW_OAUTH_ERROR_NOTIFICATION, function (title, body, opts) {
  return {
    title: title,
    body: body,
    opts: opts
  };
});
exports.showOAuthErrorNotification = showOAuthErrorNotification;
var openManageLeadSyncingModal = (0, _fluxActions.createAction)(AdsActionTypes.OPEN_MANAGE_LEAD_SYNCING_MODAL, (0, _actions.mapPayloadTo)('data'));
exports.openManageLeadSyncingModal = openManageLeadSyncingModal;
var openUnsubscribeLeadSyncingEntityModal = (0, _fluxActions.createAction)(AdsActionTypes.OPEN_UNSUBSCRIBE_LEAD_SYNCING_ENTITY_MODAL, (0, _actions.mapPayloadTo)('data'));
exports.openUnsubscribeLeadSyncingEntityModal = openUnsubscribeLeadSyncingEntityModal;
var closeModal = (0, _fluxActions.createAction)(AdsActionTypes.CLOSE_MODAL);
exports.closeModal = closeModal;